import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastService } from '../shared/toast/toast.service';

// import 'rxjs/add/operator/toPromise';

@Injectable({
  providedIn: 'root'
})

export class DbService {
  url = "";
  constructor(private http: HttpClient,private toast: ToastService) {
    let env = environment;
    this.url = env.backendapi;
   }

  // P.S. a generic get controller for any get
  async get(controller: string, method: string, queryParam?: any): Promise<any> {
    try {

      const url = (queryParam) ? this.getUrl(controller, method, queryParam) : this.getUrl(controller, method);
      const headers = this.getHeaders();

      return await this.http.get<any>(url, { headers }).toPromise();
    } catch (error: any) {
      console.log('Error in database.service.get: ' + error.message);
      this.toast.danger(error.message);
      console.log(error.message);
    }
  }
  async delete(controller: string, method: string, queryParam: any): Promise<any> {
    try {
      const headers = this.getHeaders();
      const url = this.getUrl(controller, method, queryParam);

      return await this.http.delete<any>(url, { headers }).toPromise();
    } catch (error: any) {
      console.log('Error in database.service.get: ' + error.message);
      this.toast.danger(error.message);
      console.log(error.message);
    }
  }

  async post(controller: string, method: string, body: any, queryParam?: any): Promise<any> {
    try {
      const headers = this.getHeaders();
      const url = (queryParam) ? this.getUrl(controller, method, queryParam) : this.getUrl(controller, method);
      return await this.http.post<any>(url, body, { headers }).toPromise();
    } catch (error: any) {
      this.toast.danger(error.message);
      console.log(error.message);
    }
  }

  async put(controller: string, method: string, body: any, queryParam?: any): Promise<any> {
    try {
      const headers = this.getHeaders();
      const url = (queryParam) ? this.getUrl(controller, method, queryParam) : this.getUrl(controller, method);
      return await this.http.put<any>(url, body, { headers }).toPromise();
    } catch (error: any) {
      this.toast.danger(error.message);
      console.log(error.message);
    }
  }

  private getHeaders() {
    const token = sessionStorage.getItem('token');
    let headers = new HttpHeaders();
    if (token!=null) { headers = headers.set('Authorization', "bearer " + token); }
    return headers;
  }

  private alertError(type: any, error: any) {
    console.log('Error in ' + type + ' request: ' + error.message);
    let s = error.message;
    if (error.error != null && error.error.message != null) {
      s += s + '\n' + error.error.message;
      console.log(error.message);
      this.toast.danger(error.message);
    }
  }
  private getUrl(controller: string, method: string, queryParam?: any): string {
    let url = this.url + controller + '/' + method;
    if (queryParam) {
      url += '?';
      for (const key in queryParam) {
        if (queryParam.hasOwnProperty(key)) {
          url += key + '=' + queryParam[key] + '&';
        }
      }
      return url.substr(0, url.length - 1);
    };
    return url;
  }

}
